module.exports = __webpack_public_path__ + "static/media/verifyotp.cb853e6f.svg";